/* @flow */
import navigation from 'services/NavigationService';

import { apiService } from 'services/ServiceRegistry';

import Form from '../../_.extend';

export const makeFields: Function = (assetData: Object, t: Function) => {
  return [
    {
      // DOWNLOAD CSV TEMPLATE
      name: 'downloadCsvTamplate',
      label: t('general:labels.download_csv'),
      fields: [
        {
          name: 'csvTemplate',
          label: 'Template',
          rules: '',
          value: '',
        },
      ],
    },
    {
      // CHOOSE ACCOUNT
      name: 'chooseAccount',
      label: t('general:actions.choose_account'),
      fields: [
        {
          name: 'tradingAccount',
          label: t('general:actions.choose_trading_account'),
          rules: 'required|string',
          value: null,
          extra: {
            selectID: null,
          },
        },
      ],
    },
    {
      // UPLOAD CSV
      name: 'uploadCsv',
      label: t('general:labels.upload_csv'),
      fields: [
        {
          name: 'csvFile',
          label: t('general:labels.file_upload'),
          rules: 'required|file_extension:csv|max_file_size',
          value: '',
        },
      ],
    },
  ];
};

class MultipleAssetFormCreate extends Form {}

export const assetCreate: Function = (fields: Array<*>, localState: Object, t: Function) => {
  const hooks: Object = {
    onSuccess(form: Object) {
      localState.isLoading = true;
      localState.responseMessage = t('general:messages.saving_form');
      localState.showResponseMessage = true;
      localState.hasError = false;
      localState.hasSuccess = true;

      const { csvFile }: Object = form.values().uploadCsv;

      const vFormdata = new FormData();
      vFormdata.append('account_id', form.$('chooseAccount.tradingAccount').extra.selectID);
      vFormdata.append('file', csvFile);

      const vHeaders: Headers = new Headers();
      // vHeaders.set('Content-Type', 'application/x-www-form-urlencoded');
      // vHeaders.set('X-Requested-With', 'XMLHttpRequest');

      apiService
        .createFileResource('assets/internal-upload', vFormdata, vHeaders)
        .then((response: Object) => {
          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_success');

          setTimeout(() => {
            localState.showResponseMessage = false;
            /*eslint-disable max-nested-callbacks*/
            setTimeout(() => {
              // Snackbar animation 225ms
              navigation.goBack();
            }, 225);
          }, 1200);

          return response;
        })

        .catch((err: string) => {
          localState.isLoading = false;
          localState.responseMessage =
            err && err.errors && err.errors.name && err.errors.name.length > 0
              ? err.errors.name[0]
              : err && err.message;
          localState.hasSuccess = false;
          localState.hasError = true;
        });
    },
    onError(form: Object) {
      localState.isLoading = false;
      localState.responseMessage = t('general:messages.form_error');
      localState.showResponseMessage = true;
      localState.hasSuccess = false;
      localState.hasError = true;
    },
  };

  return new MultipleAssetFormCreate(
    { fields },
    { hooks, name: t('general:actions.add_multiple_assets') }
  );
};
